import { render, staticRenderFns } from "./ChannelsCategoriesListItem.vue?vue&type=template&id=07084cd0&scoped=true&"
import script from "./ChannelsCategoriesListItem.vue?vue&type=script&lang=js&"
export * from "./ChannelsCategoriesListItem.vue?vue&type=script&lang=js&"
import style0 from "./ChannelsCategoriesListItem.vue?vue&type=style&index=0&id=07084cd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07084cd0",
  null
  
)

export default component.exports